export function trackConversion() {
  const sendTo = process.env.REACT_APP_GADS_SEND_TO;
  if (!sendTo || typeof window.gtag !== "function") return;
  window.gtag("event", "conversion", { send_to: sendTo, value: 1.0, currency: "EUR" });
}
